import { MusicAPIIntegrationID } from 'fym-shared/src/music-services/ids';

/**
 * The `oauthRedirect` portals whose sign-in MusicAPI runs and that come back to the generic return
 * page `/app/catalog/connect/<integrationType>?state=<sessionUuid>` (Audiomack, 2026-10-16).
 * SoundCloud has its own return page (`../soundCloud/`), because it lands on Channels.
 */
const RETURN_PAGE_PORTALS: readonly string[] = [MusicAPIIntegrationID.Audiomack];

export function isReturnPagePortal(integrationType: string | undefined): boolean {
  return integrationType !== undefined && RETURN_PAGE_PORTALS.includes(integrationType);
}
